import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { setIsSeo } from '../../model/serpPresenceSlice'

interface PaidResultsCellProps {
  keyword_id: number
  paid_count?: number
  expandedRowKeys?: string[]
  is_seo?: boolean
  onExpandRow?: (isShow: boolean, key: string) => void
}

export const PaidResultsCell = ({
  keyword_id,
  paid_count,
  expandedRowKeys,
  is_seo,
  onExpandRow,
}: PaidResultsCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const key = `${keyword_id}`

  if (!paid_count) {
    return (
      <div className='flex h-6 items-center'>
        <span className='block h-2 w-2 rounded-full bg-[#D9D9D9]'></span>
      </div>
    )
  }

  return (
    <div className='flex items-center'>
      <span className='w-7'>{paid_count}</span>

      {expandedRowKeys?.includes(key) && !is_seo ? (
        <span
          className={
            'ml-4 cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'
          }
          onClick={() => {
            onExpandRow && onExpandRow(false, key)
          }}
        >
          {t('buttons.close')}
        </span>
      ) : (
        <span
          className={
            'ml-4 cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'
          }
          onClick={() => {
            onExpandRow && onExpandRow(true, key)
            dispatch(setIsSeo(false))
          }}
        >
          {t('buttons.show')}
        </span>
      )}
    </div>
  )
}
